import { Component, OnInit, Input, ViewEncapsulation, OnChanges, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { ProductsRouterService } from 'src/app/services/api/router/products-router.service';
import { TabObject } from 'src/app/models/products/item/tab-object.model';
import { ItemObject } from 'src/app/models/products/item/item-object.model';
import { ProductTypeObject } from 'src/app/models/products/product-type-object.model';
import { Product } from 'src/app/models/interface/product/product';
import { TreeCardObject } from 'src/app/models/products/tree-card/tree-card-object.model';
import { ProductItemConverter } from 'src/app/services/api/item/productItem.converter';
@Component({
  selector: 'app-products-tree-card',
  templateUrl: './products-tree-card.component.html',
  styleUrls: ['./products-tree-card.component.scss']
})
export class ProductsTreeCardComponent implements OnInit {

  @Input() item: Product;
  @Input() treeCard: TreeCardObject;
  @Output() onClickEvent = new EventEmitter<TreeCardObject>();

  constructor(private routerService: ProductsRouterService, private productItemConverter: ProductItemConverter) {
    this.treeCard = TreeCardObject.create();
  }

  ngOnInit() {
  }


  private clickCard() {
    this.treeCard.click();
    this.onClickEvent.emit(this.treeCard);
  }

  public onClickGeneral() {
    this.clickCard();
    this.navigateTo(TabObject.INFORMATION_TAB);
  }

  public onClickProcesses() {
    this.clickCard();
    this.navigateTo(TabObject.PROCESSES_TAB);
  }

  public onClickDependencies() {
    this.clickCard();
    this.navigateTo(TabObject.DEPENDENCIES_TAB);
  }

  private navigateTo(tab: TabObject) {
    const newItem: ItemObject = this.productItemConverter.convert(this.treeCard);
    newItem.tab = this.getTabByType(tab, newItem.type);
    this.routerService.navigate(newItem);
  }

  private getTabByType(currentTab: TabObject, type: ProductTypeObject): TabObject {

    return currentTab;
  }

  isService(type: ProductTypeObject): boolean {
    return type.equals(ProductTypeObject.CFS) || type.equals(ProductTypeObject.RFS);
  }
}
